import { render, staticRenderFns } from "./MdTablePagination.vue?vue&type=template&id=3446aaf0&"
import script from "./MdTablePagination.vue?vue&type=script&lang=js&"
export * from "./MdTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./MdTablePagination.vue?vue&type=style&index=0&id=3446aaf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports